module.exports = __webpack_public_path__ + "img/female-ico.e9e20b1d.svg";